﻿/**
 * portal-group.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-group.controller', portalGroupController);

	/** setup injection */
	portalGroupController.$inject = ['$scope', '$window', '$q', '$timeout', 'portal-link-group-link.repository', 'portal-favorites.manager'];

	/** implementation */
	function portalGroupController($scope, $window, $q, $timeout, portalLinkGroupLinkRepository, portalFavoritesManager) {
		/** private properties */
		var windowElement = angular.element($window);
		var groupLinks = [];
		
		/** pubic properties */
		var vm = this;
		vm.loading = false;
		vm.showLinks = false;
		vm.groupLinks = [];
		vm.fixedLinks = false;

		/** public methods */
		vm.viewLinks = viewLinks;
		vm.close = close;

		/** run init */
		init();

		/** public method implementations */

		/** view the links for the group */
		function viewLinks() {
			/** check for preview */
			if (vm.preview) return;

			/** flip loading flag */
			vm.loading = true;

			/** show the links area */
			vm.showLinks = true;

			/** set the onScroll handler */
			windowElement.on('scroll', positionHandler);
			$scope.$on('$destroy', function() {
				windowElement.off('scroll', positionHandler);
			});
			positionHandler();

			/** load the links */
			loadLinks().then(function(gl) {
				/** set timeout so that links display properly */
				$timeout(function() {
					/** set group links */
					vm.groupLinks = gl;

					/** flip loading flag */
					vm.loading = false;
				}, 300);
			});
		}

		/** close the links window */
		function close() {
			/** show the links area */
			vm.showLinks = false;

			/** empty links */
			vm.groupLinks = [];

			/** destroy the scroll event */
			windowElement.off('scroll', positionHandler);
		}

		/** private methods */

		/** initialize */
		function init() {
			/** set the favorites callback */
			portalFavoritesManager.addCallback('portal-favorites', adjustFavorites, false, $scope);
		}

		/** load the related links */
		function loadLinks() {
			/** create a promise */
			var deferred = $q.defer();

			/** check for links */
			if (groupLinks.length > 0) {
				/** set the current context */
				deferred.resolve(groupLinks);
			} else {
				/** load the links */
				portalLinkGroupLinkRepository.getForGroup(vm.group.portalLinkGroupID).then(function(gl) {
					/** set the group links */
					groupLinks = gl;

					/** set the current context */
					deferred.resolve(groupLinks);
				});
			}

			/** return the promise */
			return deferred.promise;
		}

		/** position handler */
		function positionHandler() {
			/** event must fire in scope */
			$timeout(function() {
				/** get the scroll position */
				var scrollY = $window.scrollY || $window.pageYOffset;

				/** check the value */
				if (scrollY > 84) vm.fixedLinks = true;
				else vm.fixedLinks = false;
			});
		}

		/** adjust the favorites */
		function adjustFavorites(favorites) {
			/** adjust the group link isFavorite star */
			_.forEach(groupLinks, function(gl) {
				/** default the link to isFavorite = false */
				gl.portalLink.isFavorite = false;

				/** find a match in favorites */
				var match = favorites.filter(function(fav){ return fav.portalLinkID === gl.portalLinkID; });
				if (match.length > 0) gl.portalLink.isFavorite = true;
			});
		}
	}
})();